// See https://github.com/facebook/create-react-app/tree/master/packages/react-app-polyfill
// for instructions for how to control the included polyfills.
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import '@ver-uds/styles';
import App from './App';
import type { Worker } from './mocks/browser';
import setupFakeAuth from './context/Security/setupFakeAuth';

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const worker = (require('./mocks/browser') as { default: Worker }).default;

  // If you want your app to mock server calls in the browser, you can comment
  // out the worker.stop() call and uncomment the worker.start() call below.
  // You also need changes in browser.ts (see comments over there)
  worker.stop();

  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  // worker.start({
  //   serviceWorker: {
  //     url: '/account/mockServiceWorker.js',
  //   },
  // });

  if (process.env.REACT_APP_FAKE_AUTH === 'true') {
    setupFakeAuth();
  }
}

ReactDOM.render(
  <React.StrictMode>
    {/* To test dashboard redirect:
        - uncomment block below
        - Run eve-home-ui and login through login.gov
        - Stop running eve-home-ui and run eve-account-ui */}
    {/* <BrowserRouter>
      <Route exact path="/dashboard">
        <div>MOCKEDBOARD</div>
      </Route>
    </BrowserRouter> */}
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
